module.exports = __webpack_public_path__ + "img/confetti2.7cb03fc5.png";